export default __webpack_public_path__ + "static/media/commonoceanmaindemo.64ab6375.gif";